import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const STORAGE_KEY = 'cookie_consent';

export default function CookieBanner() {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(STORAGE_KEY)) {
      setVisible(true);
    }
  }, []);

  function accept() {
    localStorage.setItem(STORAGE_KEY, 'accepted');
    setVisible(false);
  }

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 sm:p-6">
      <div className="max-w-4xl mx-auto bg-white border border-gray-200 rounded-xl shadow-2xl shadow-gray-900/10 p-5 flex flex-col sm:flex-row sm:items-center gap-4">
        {/* Cookie icon */}
        <div className="flex-shrink-0 w-10 h-10 bg-accent-100 rounded-full flex items-center justify-center text-xl">
          🍪
        </div>

        <div className="flex-1 min-w-0">
          <p className="text-sm font-semibold text-gray-900 mb-1">{t('cookie.title')}</p>
          <p className="text-sm text-gray-500 leading-snug">
            {t('cookie.body')}{' '}
            <Link to="/datenschutz" className="text-primary-600 hover:text-primary-700 underline underline-offset-2">
              {t('footer.datenschutz')}
            </Link>
            {' '}&amp;{' '}
            <Link to="/impressum" className="text-primary-600 hover:text-primary-700 underline underline-offset-2">
              {t('footer.impressum')}
            </Link>.
          </p>
        </div>

        <button
          onClick={accept}
          className="flex-shrink-0 btn btn-primary btn-sm whitespace-nowrap"
        >
          {t('cookie.accept')}
        </button>
      </div>
    </div>
  );
}
